import { SERVICE_PAYMENT_STATUS } from 'utils/enums';

export const SERVICE_PAYMENTS_HEADER_TITLES = {
	CREATED_AT: 'Створено',
	PAID_AT: 'Дата оплати',
	MAIN_BILL_ID: 'ID пакету',
	SEPARATION_TYPE: 'Тип платежу',
	PARTNER: 'Партнер',
	SERVICE_PROVIDER: 'Сервіс',
	SERVICE_NAME: 'Послуга',
	CHILD_BILL_ID: 'BillId',
	PARENT_BILL_ID: 'parentBillId',
	BANK: 'Банк',
	AMOUNT: 'Сума',
	FEE: 'Комісія',
	PAID_AMOUNT: 'Списано',
	STATUS: 'Статус',
	CLIENT_PHONE: 'Номер телефону клієнта',
	CARD: 'Картка',
};

export const SERVICE_PAYMENTS_STATUS_OPTIONS = [
	{ value: SERVICE_PAYMENT_STATUS.NEW, title: 'NEW' },
	{ value: SERVICE_PAYMENT_STATUS.CONFIRMED, title: 'CONFIRMED' },
	{ value: SERVICE_PAYMENT_STATUS.PENDING, title: 'PENDING' },
	{ value: SERVICE_PAYMENT_STATUS.PAID, title: 'PAID' },
	{ value: SERVICE_PAYMENT_STATUS.REJECTED, title: 'REJECTED' },
	{ value: SERVICE_PAYMENT_STATUS.EXPIRED, title: 'EXPIRED' },
	{ value: SERVICE_PAYMENT_STATUS.CANCELED, title: 'CANCELED' },
	{ value: SERVICE_PAYMENT_STATUS.RETURNED, title: 'RETURNED' },
	{ value: SERVICE_PAYMENT_STATUS.NEEDS_CONFIRMATION, title: 'NEEDS CONFIRMATION' },
];
